// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TZlZ","rootNoMargin":"styles_rootNoMargin__12DLz"};